var exports = {
  "k": "x52a3aa3b--904a67--container",
  "A": "x52a3aa3b--904a67--item",
};

module.exports = exports;
